<template>
    <div class="field">
        <input
            :value="value"
            @input="$emit('input', $event.target.value)"
            :disabled="disabledInput"
            :type="typeInput"
            :readonly="readonlyInput"
            v-bind="$attrs"
            class="custom-field"
        >
    </div> 
</template>

<script>

    export default {
        name: 'FieldInput',
        inheritAttrs: true,
        props: {
            value: String,
            type: String,
            disabled: Boolean,
            readonly: Boolean
        },
        computed: {
            typeInput: function() {
                return this.type;
            },
            disabledInput() {
                return this.disabled;
            },
            readonlyInput() {
                return this.readonly;
            }
        }
    }
</script>

<style scoped>
    .field {
        display: inline-block;
    }

    .field .custom-field {
        outline-color: #ffa409;
        height: 60px;
        width: 100%;
        border: 1px solid #d9dee3;
        border-radius: 15px;
        font-size: 18px;
        padding: 13px 17px;
        background-color: #fff;
    }

    .field .custom-field:disabled {
        background-color: #e9ecef;
        color: #000;
    }

    .field .custom-field::placeholder {
        font-size: 18px;
        font-weight: 300;
    }
</style>